/* ========================================================
	Mobile menu click for submenu
======================================================== */

function mobileMenu() {

    $('.hamburger').click(function(ev) {
        ev.preventDefault();

        $('body').toggleClass('menu-active');
    });

    $('.dropdown-toggle').on('click', function(ev) {
        ev.preventDefault();
        var parent   = $(this),
            dropdown = parent.next();

        parent.toggleClass('dropdown-active');
        dropdown.slideToggle(250);
    });

}
